import { createAction, props } from '@ngrx/store';
import { User } from '../../models/user';

export const LogIn = createAction(
  '[Auth] Login',
  props<{ email: string; password: string }>()
);

export const LogInSuccess = createAction(
  '[Auth] Login Success',
  props<{ user: User}>()
);

export const LogInFailure = createAction(
  '[Auth] Login Failure',
  props<{ error: any }>()
);

export const SignUp = createAction(
  '[Auth] Sign Up', 
  props<{ email: string; password: string; firstName:string; lastName : string }>()
);
export const SignUpSuccess = createAction(
  '[Auth] Sign Up Success',
  props<{ token: string ; email: string }>()
);
export const SignUpFailure = createAction(
  '[Auth] Sign Up Failure',
  props<{ error: any }>()
);


export const LogOut = createAction('[Auth] Logout');
